import ReactDOM from 'react-dom';
import React from 'react';
import AssignTasksModalNativeWrapper from '../../../../../../client/features/AssignTasksModalNativeWrapper';
import { App } from '../App';
import { appConfig as $config } from '../../app.config';
import { UI } from '../../modules/UI';
import { User } from '../../modules/User';

export const AssignTasks = (function () {
  const handleAssignTask = ({ e, elClassName, selectedPageField, requestPage }) => {
    let target = $(e.target).hasClass(elClassName) ? $(e.target) : $(e.target).closest('.' + elClassName);
    let id = target.data('id');
    let title = target.data('title');
    let items = [];
    
    const defaultAccountId = User.accountID();
    
    if (!id || !title) {
      let selected = App.pageData(selectedPageField);
      if (selected && selected.length) {
        selected.forEach((item) => {
          items.push({
            id: item.id,
            title: item.title,
            accountId: item.accountId || defaultAccountId,
          });
        });
      } else {
        return false;
      }
    } else {
      items.push({ id: id, title: title, accountId: defaultAccountId });
    }
    dialog({ items: items, page: requestPage });
  };

  const dialog = ({ items: items, page: page }) => {
    if ($('#assign-tasks-modal-container').length) {
      handleAssignModalClose();
    } else {
      $('<div id="assign-tasks-modal-container" />').appendTo('body');
    }

    ReactDOM.render(
      React.createElement(AssignTasksModalNativeWrapper, {
        entityType: page,
        entitiesIds: items.map((item) => {
          return {
            itemId: item.id,
            accountId: item.accountId
          }
        }),
        accountId: User.accountID(),
        url: $config.apiURL,
        onMessageShow: handleMessageShow,
        onErrorShow: handleErrorShow,
        onClose: handleAssignModalClose
      }),
      document.getElementById('assign-tasks-modal-container')
    );
  };

  const handleAssignModalClose = () => {
    ReactDOM.unmountComponentAtNode(document.getElementById('assign-tasks-modal-container'));
  };

  const handleMessageShow = (text) => {
    UI.notify({ text, type: 'success' });
  };

  const handleErrorShow = (res) => {
    UI.errorMessage(
      res.errorInformation && res.errorInformation.errorReason ? res.errorInformation.errorReason : 'Unknown error'
    );
  };

  return {
    handleAssignTask,
    dialog
  };
})();
